// extracted by mini-css-extract-plugin
export default {"ingredient":"ingredient-list_ingredient__Ky4vi","counter":"ingredient-list_counter__G3fY+"};